import styled from 'styled-components';
import { Loader as LoaderComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  width: auto;
  min-width: max-content;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: ${(props) => props.theme.color.white};
  padding: 30px;
  padding-left: 50px;
  border-radius: 4px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Content = styled.div`
`;

export const ContainerTable = styled.div`
  display: flex;
  width: auto;
  flex-direction: column;
  position: relative;
  margin-top: 20px;
  padding: 0 20px 20px 0;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  background-color: ${(props) => props.theme.color.white};
  border-radius: 4px;
`;

export const Tooltip = styled.div`
  padding: 10px;
  min-width: 400px;
  width: auto;
  height: auto;
  display: flex;
  position: absolute;
  top: 30px;
  background-color: ${(props) => props.theme.color.white};
  z-index: 999;
  border: 1px solid #C5C5C5;
  border-radius: 3px;
  overflow-wrap: anywhere;
`;

const RGB = '#477ae9';
// background-color: ${(props) => `rgba(0,0,255, ${props.opacity})`};
export const CellContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: ${(props) => `rgba(
    ${+parseInt(RGB.substring(1, 3), 16)},
    ${+parseInt(RGB.substring(3, 5), 16)},
    ${+parseInt(RGB.substring(5, 7), 16)},
    ${props.opacity})`
  };
  color: ${(props) => props.theme.color.textSecondary};
  padding: 5px;
  min-width: 40px;
  max-width: 40px;
`;

export const RowTitle = styled.div`
  padding-left: 15px;
  padding-top: 5px;
  background-color: ${(props) => (props.highlight ? '#EED15C' : props.theme.color.white)}
`;

export const GradientBar = styled.div`
  background: linear-gradient(to right, #FFFFFF 0%, #477ae9 100%);
  min-width: 400px;
  height: 10px;
  display: inline-block;
`;

export const HeaderText = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

export const Loader = styled(LoaderComponent)`
  &&& {
    margin: auto;
  }
`;
